import React from 'react';
import { Collapse, Navbar, Form, FormControl, Button, NavbarToggle, NavbarBrand, Nav, NavItem, NavLink } from 'react-bootstrap';
import { BrowserRouter as Router } from "react-router-dom";

import { Container } from '@mui/material'
import 'bootstrap/dist/css/bootstrap.min.css';
import './app/fichierCss/App.css';
import './app/fichierCss/Accueil.css'
import './app/fichierCss/Footer.css'
import Routes from './app/routes/RouteNavigation'
import Entete from './app/composants/Entete'
import Footer from './app/composants/Footer'
import NavigationContainer from './app/container/NavigationContainer'
import Connexion from './app/composants/Connexion'


import history from './app/services/History'

function App() {
    return ( 
    <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
        <Connexion/>      
        <Router>
            <React.Fragment>
                <Entete />
                <NavigationContainer/>
                <Routes/> 
            </React.Fragment>         
        </Router> 
        <Footer />          
    </Container>

    );
}
export default App; 